import { type Row, type Table } from '@tanstack/react-table';
import { jsPDF } from 'jspdf';
import autoTable, { type RowInput } from 'jspdf-autotable';
import { type DataTableColumnDef } from '../models/DataTableColumnDef';
import { getRowValue } from '@/app/modules/export/getRowValue';
import { type ExportConfig } from '../modules/export/types';

/**
 * New export function using ExportConfig
 */
export function exportToPDFFromConfig(config: ExportConfig) {
  const { columns, rows, orientation = 'portrait', filename = 'table.pdf' } = config;

  const doc = new jsPDF({ orientation });

  const tableHeaders = columns.map((col) => col.header);

  const tableRows = rows.map((row) =>
    columns.map((col) => {
      const value = getRowValue(row, col.key);
      if (col.format) {
        return col.format(row) ?? '';
      }
      return value !== undefined && value !== null ? String(value) : '';
    }),
  );

  autoTable(doc, {
    head: [tableHeaders as RowInput],
    body: tableRows,
  });

  doc.save(filename);
}

/**
 * @deprecated Use exportToPDFFromConfig with ExportConfig instead.
 * Kept for backward compatibility.
 */
export function exportToPDF(columns: DataTableColumnDef<object>[], table?: Table<object>) {
  if (!table) return;

  const doc = new jsPDF();

  const tableColumn = columns.filter((column) => column && column.isPrintable !== false).map((col) => col.header || '');

  const tableRows = table.getRowModel().rows.map((row: Row<object>) =>
    columns
      .filter((column) => column && column.isPrintable !== false)
      .map((column) => {
        const value = column.print?.(row) || row.getValue(column.id as string);
        return value !== undefined ? value : '';
      }),
  );

  autoTable(doc, {
    head: [tableColumn as RowInput],
    body: tableRows,
  });

  doc.save('table.pdf');
}
